module.exports = __webpack_public_path__ + "static/media/Shreeya_Patel_CV_.b6ff628b.pdf";